export const CRMEstimate = [
  {
    estimate_number: "EST-2659",
    amount: "Rs.12,390.00",
    total_tax: "Rs.1,890.00",
    customer: "Glo LED Private Limited",
    project: "LED Lighting Solutions",
    tags: ["LED", "Lighting", "Energy Efficient"],
    date: "22/03/2025",
    expiry_date: "25/06/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2658",
    amount: "Rs.7,080.00",
    total_tax: "Rs.1,080.00",
    customer: "Fresh Farm To Home",
    project: "Organic Food Supply",
    tags: ["Organic", "Farm Fresh", "Food Delivery"],
    date: "21/03/2025",
    expiry_date: "30/06/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2653",
    amount: "Rs.18,880.00",
    total_tax: "Rs.2,880.00",
    customer: "BlueWave Technologies",
    project: "Cloud Infrastructure Setup",
    tags: ["Cloud", "Infrastructure", "IT"],
    date: "09/03/2025",
    expiry_date: "15/07/2026",
    reference_number: "",
    status: "Accepted",
  },
  {
    estimate_number: "EST-2652",
    amount: "Rs.24,780.00",
    total_tax: "Rs.3,780.00",
    customer: "Green Earth Landscapes",
    project: "Commercial Garden Development",
    tags: ["Landscaping", "Garden", "Commercial"],
    date: "08/03/2025",
    expiry_date: "05/07/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2651",
    amount: "Rs.9,440.00",
    total_tax: "Rs.1,440.00",
    customer: "Skyline Constructions",
    project: "Building Material Supply",
    tags: ["Construction", "Materials", "Supply"],
    date: "07/03/2025",
    expiry_date: "15/05/2026",
    reference_number: "",
    status: "Draft",
  },
  {
    estimate_number: "EST-2650",
    amount: "Rs.15,340.00",
    total_tax: "Rs.2,340.00",
    customer: "Apex Healthcare",
    project: "Medical Equipment Procurement",
    tags: ["Healthcare", "Medical", "Equipment"],
    date: "06/03/2025",
    expiry_date: "20/07/2026",
    reference_number: "",
    status: "Accepted",
  },
  {
    estimate_number: "EST-2649",
    amount: "Rs.32,450.00",
    total_tax: "Rs.4,950.00",
    customer: "Urban Mobility Solutions",
    project: "Electric Vehicle Charging Stations",
    tags: ["EV", "Charging", "Infrastructure"],
    date: "05/03/2025",
    expiry_date: "20/06/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2648",
    amount: "Rs.6,490.00",
    total_tax: "Rs.990.00",
    customer: "Royal Bakers",
    project: "Bakery Equipment Upgrade",
    tags: ["Bakery", "Food", "Equipment"],
    date: "04/03/2025",
    expiry_date: "01/07/2026",
    reference_number: "",
    status: "Declined",
  },
  {
    estimate_number: "EST-2647",
    amount: "Rs.27,140.00",
    total_tax: "Rs.4,140.00",
    customer: "Ocean Logistics",
    project: "Warehouse Management System",
    tags: ["Logistics", "Warehouse", "Software"],
    date: "03/03/2025",
    expiry_date: "25/07/2026",
    reference_number: "",
    status: "Accepted",
  },
  {
    estimate_number: "EST-2646",
    amount: "Rs.11,210.00",
    total_tax: "Rs.1,710.00",
    customer: "Elite Fitness Club",
    project: "Gym Equipment Installation",
    tags: ["Fitness", "Gym", "Installation"],
    date: "02/03/2025",
    expiry_date: "10/08/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2645",
    amount: "Rs.19,470.00",
    total_tax: "Rs.2,970.00",
    customer: "Bright Minds Academy",
    project: "Digital Classroom Setup",
    tags: ["Education", "Smart Classroom", "Technology"],
    date: "01/03/2025",
    expiry_date: "28/06/2026",
    reference_number: "",
    status: "Draft",
  },
  {
    estimate_number: "EST-2644",
    amount: "Rs.41,300.00",
    total_tax: "Rs.6,300.00",
    customer: "Nova Manufacturing Pvt Ltd",
    project: "Industrial Automation System",
    tags: ["Automation", "Manufacturing", "Industrial"],
    date: "28/02/2025",
    expiry_date: "18/07/2026",
    reference_number: "",
    status: "Accepted",
  },
  {
    estimate_number: "EST-2657",
    amount: "Rs.3,540.00",
    total_tax: "Rs.540.00",
    customer: "Heritage Arts",
    project: "Traditional Art Sales",
    tags: ["Handicrafts", "Cultural", "Art"],
    date: "21/03/2025",
    expiry_date: "30/07/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2656",
    amount: "Rs.13,000.00",
    total_tax: "Rs.0.00",
    customer: "Murra.Jeans.Co",
    project: "Denim Apparel Manufacturing",
    tags: ["Fashion", "Denim", "Clothing"],
    date: "19/03/2025",
    expiry_date: "12/08/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2655",
    amount: "Rs.61,360.00",
    total_tax: "Rs.9,360.00",
    customer: "FUTURETECH",
    project: "Tech Innovation & Development",
    tags: ["Technology", "Innovation", "Software"],
    date: "19/03/2025",
    expiry_date: "01/09/2026",
    reference_number: "",
    status: "Sent",
  },
  {
    estimate_number: "EST-2654",
    amount: "Rs.10,620.00",
    total_tax: "Rs.1,620.00",
    customer: "GMR Hospitality And Retail Limited",
    project: "Hospitality & Retail Expansion",
    tags: ["Hospitality", "Retail", "Expansion"],
    date: "10/03/2025",
    expiry_date: "07/07/2026",
    reference_number: "",
    status: "Sent",
  },
];
